/* eslint-disable no-constant-condition */
import { Card, CardBody } from '@components/card/card';
import CustomAlert from '@components/Shared/Alert/CustomAlert';
import useGetEquipmentsList from '@hooks/FLeet/useGetEquipmentsList';
import { UpdatEquipmentsAssignment } from '@store/FLEET/EquipmentsAssignment/equipmentsAssignmentSlice';
import { GetScanningElementList } from '@store/FLEET/FleetScan/fleetScanSlice';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { useFormik } from 'formik';
import { useEffect, useState } from 'react';
import { CardHeader, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import Button from 'react-bootstrap/Button';
import PopoverCustom from '@components/Shared/Popover/PopoverCustom';
import FileUpload from '../../../components/Files/FileUpload';
import Kuroki from '../FleetScan/Kuroki';
import Loading from '@components/Shared/Loader/Loading';
import useGetDriversList from '@hooks/FLeet/useGetDriversList';
import { GetEquipmentsList } from '@store/FLEET/Equipments/equipmentsSlice';
import DetilesScan from '../EquipmentsAssignment/DetilesScan';
import { useNavigate, useParams } from 'react-router-dom';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { EquipmentTakeOverSchema } from '@pages/ValidationForm/validationSchema';

// equipmentsAssignationDate,
// equipmentsAssignationId,
// onclose
const TakeOver = () => {
  const { Id } = useParams();

  const [attachments, setAttachments] = useState<File[]>([]);
  const { t, i18n } = useTranslation();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { OptionsEquipments, EquipmentsList, error, loading } = useGetEquipmentsList();
  const { OptionsDrivers, loading: loading1, error: error1 } = useGetDriversList();
  const EquipmentData = EquipmentsList?.find(f => f.id === Id);
  const { ScanElementList, loading: loading2, error: error2 } = useAppSelector(state => state.FleetScan);

  useEffect(() => {
    dispatch(GetScanningElementList({ modelId: EquipmentData?.fleetModelId }));
  }, [EquipmentData, dispatch]);

  const formik = useFormik({
    initialValues: {
      id: EquipmentData?.equipmentsAssignationId,
      // id:  equipmentsAssignationId,
      fleetEquipmentsId: Id,
      peopleId: EquipmentData?.peopleId,
      // deliveryDateFrom: equipmentsAssignationDate,
      deliveryDateFrom: EquipmentData?.equipmentsAssignationDate,
      DeliveryDateTo: '',
      description: '',
      odometer: 0,

      //--------------
      details: ScanElementList?.scanningElements?.map(item => ({
        // scanningMasterId: null,
        scanningElementId: item.id,
        value: '1',
        description: ''
      })),
      attachments: [],
      isAddAttach: false,
      markers: [
        // {
        //   xPosition: '',
        //   yPosition: '',
        //   shape: '',
        //   color: '',
        //   comment: '',
        //   size: ''
        // }
      ]
    },
    enableReinitialize: true,
    validationSchema: EquipmentTakeOverSchema(t),
    onSubmit: values => {
      const formData = new FormData();
      formData.append('Id', values.id || '');
      formData.append('FleetEquipmentsId', values.fleetEquipmentsId || '');
      formData.append('PeopleId', values.peopleId || '');
      formData.append('DeliveryDateFrom', values.deliveryDateFrom || '');
      formData.append('DeliveryDateTo', values.DeliveryDateTo || '');
      formData.append('Description', values.description || ' ');
      formData.append('Scanning.LookupType', '');
      formData.append('Scanning.Odometer', values.odometer?.toString() || '');

      formData.append('Scanning.FleetEquipmentsId', values.fleetEquipmentsId || '');
      formData.append('Scanning.DriverId', values.peopleId || '');
      formData.append('Scanning.ScanningCode', '');
      formData.append('Scanning.ScanningDate', values.DeliveryDateTo || '');
      formData.append('Scanning.Description', values.description || '');
      formData.append('Scanning.IsAddAttach', values.isAddAttach ? 'true' : 'false');

      // رفع المرفقات
      if (values.attachments && values.attachments.length > 0) {
        values.attachments.forEach(file => {
          formData.append('Scanning.Attach', file); // file من نوع File أو Blob
        });
      }

      // Append details to formData
      values.details.forEach((detail, index) => {
        formData.append(`Scanning.Details[${index}].scanningElementId`, detail.scanningElementId);
        formData.append(`Scanning.Details[${index}].value`, detail.value === '1' ? 'true' : 'false');

        formData.append(`Scanning.Details[${index}].description`, detail.description);
      });

      // Append Markers to formData
      values.markers.forEach((marker: any, index) => {
        formData.append(`Scanning.Markers[${index}].xPosition`, marker.x?.toString() ?? '');
        formData.append(`Scanning.Markers[${index}].yPosition`, marker.y?.toString() ?? '');
        formData.append(`Scanning.Markers[${index}].shape`, marker.shape ?? '');
        formData.append(`Scanning.Markers[${index}].color`, marker.color ?? '');
        formData.append(`Scanning.Markers[${index}].comment`, marker.comment ?? '');
        formData.append(`Scanning.Markers[${index}].size`, marker.size?.toString() ?? '');
      });

      dispatch(UpdatEquipmentsAssignment(formData))
        .unwrap()
        .then(res => {
          if (res?.succeeded === true) {
            CustomAlert({
              action: 'Add',
              msg: i18n.language === 'en' ? 'Take over completed successfully.' : 'تم الاستلام  بنجاح.'
            });
            dispatch(GetEquipmentsList());
            navigate('/FLEET/TakeOver', { replace: true });
          } else {
            formik.setSubmitting(false);
            CustomAlert({ action: 'Error', msg: res?.message });
          }
        })
        .catch((error: any) => {
          formik.setSubmitting(false);
          CustomAlert({ action: 'Error' });
        });
    }
  });

  const handleAttachments: React.Dispatch<React.SetStateAction<File[]>> = value => {
    setAttachments(prev => {
      const newAttachments = typeof value === 'function' ? value(prev) : value;
      if (newAttachments.length > 0) {
        formik.setFieldValue('attachments', newAttachments);
        formik.setFieldValue('isAddAttach', true);
      } else {
        formik.setFieldValue('attachments', []);
        formik.setFieldValue('isAddAttach', false);
      }
      return newAttachments;
    });
  };

  const predefinedNotesCategories = [
    {
      label: t('Oil and Filters'),
      options: [
        { id: 1, text: t('Oil change') },
        { id: 2, text: t('Oil Filter change') },
        { id: 3, text: t('Water Pump change') },
        { id: 4, text: t('Deferential oil change') },
        { id: 5, text: t('Gear oil change') }
      ]
    },
    {
      label: t('Electrical and Engine'),
      options: [
        { id: 6, text: t('Electrical work') },
        { id: 7, text: t('Clutch work') },
        { id: 8, text: t('Selfe motor work') },
        { id: 9, text: t('Dainomo work') },
        { id: 10, text: t('Engine Repair') },
        { id: 11, text: t('Engine Head work') },
        { id: 12, text: t('Diesel Pump repair work') },
        { id: 13, text: t('Diesel pump Installation works') },
        { id: 14, text: t('Diesel pump washing') }
      ]
    },
    {
      label: t('Body and Painting'),
      options: [
        { id: 15, text: t('Light work') },
        { id: 16, text: t('Tending and painting work') },
        { id: 17, text: t('Body parts work') },
        { id: 18, text: t('Welding works') },
        { id: 19, text: t('Safety barrier works') }
      ]
    },
    {
      label: t('Suspension and Wheels'),
      options: [
        { id: 20, text: t('Gear work') },
        { id: 21, text: t('Connecting Rod works') },
        { id: 22, text: t('Shockupsober works') },
        { id: 23, text: t('Tire replace works') },
        { id: 24, text: t('Wheel king pin change') },
        { id: 25, text: t('Break works') }
      ]
    },
    {
      label: t('AC and Cooling'),
      options: [
        { id: 26, text: t('Radiator work') },
        { id: 27, text: t('AC works') },
        { id: 28, text: t('Frozen unit repair') }
      ]
    },
    {
      label: t('Washing and Cleaning'),
      options: [
        { id: 29, text: t('Engine washing') },
        { id: 30, text: t('Car washing') }
      ]
    },
    // {
    //   label: t('Route Status'),
    //   options: [
    //     { id: 31, text: t('Route Number: vacation') },
    //     { id: 32, text: t('Route Number: termination') },
    //     { id: 33, text: t('Route Number: replace') },
    //     { id: 34, text: t('Route Number: No route number') }
    //   ]
    // },
    {
      label: t('MVPI and Inspection'),
      options: [{ id: 35, text: t('MVPI process work') }]
    }
  ];

  // دالة لإضافة ملاحظة جاهزة إلى الحقل
  const addPredefinedNote = (note: string) => {
    const currentNotes = formik.values.description;
    formik.setFieldValue('description', currentNotes ? `${currentNotes}\n- ${note}` : `- ${note}`);
  };

  const fieldNames: Record<string, string> = {
    odometer: t('Odometer'),
    DeliveryDateTo: t('TakeoverDate')
  };

  console.log(formik.errors);

  return (
    <>
      <div className='d-flex align-items-center  '>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
             link: ':moduleHome'
            },
            {
              name: 'Takeover',
              link: '/FLEET/TakeOver'
            },
            {
              name: 'Takeover',
              link: null
            }
          ]}
          PageName='Takeover'
          subtitle={OptionsDrivers.find(f => f.value === EquipmentData?.peopleId)?.label}
        />
      </div>
      <Loading loading={loading || loading1 || loading2} error={error || error1 || error2}>
        <ul className='nav nav-tabs mb-3 d-flex justify-content-between align-items-center'>
          <div className='d-flex'>
            <li className='nav-item'>
              <a className='nav-link active' id='pills-home-tab' data-bs-toggle='pill' href='#TakeOverForm'>
                <i className='fa-lg fas fa-clipboard-check me-2'></i>
                <span>{t('takeoverForm')}</span>
                <span className='badge bg-theme ms-2 px-3'>{OptionsEquipments.find(f => f.value === Id)?.label}</span>
              </a>
            </li>
            <li className='nav-item'>
              <a className='nav-link' id='pills-profile-tab' data-bs-toggle='pill' href='#HandoverDetiles'>
                <i className='fa-lg fas fa-file-alt me-2'></i>
                {t('handoverDetails')}
              </a>
            </li>
          </div>
        </ul>

        <div className='tab-content' id='pills-tabContent'>
          <div className='tab-pane fade show active' id='TakeOverForm'>
            <Form onSubmit={formik.handleSubmit}>
              <div className='row mb-4   '>
                <div className='col-md-12 mb-3'>
                  <Card className='h-100 '>
                    <CardBody>
                      <div className='row'>
                        <div className='col-md-4'>
                          <div className='input-group flex-nowrap'>
                            <span className='input-group-text    fw-bold'>
                              <i className='fas fa-car-side me-2'></i>
                              {t('Vehicle')}
                            </span>
                            <Select
                              isDisabled
                              classNamePrefix='react-select'
                              // className='w-100 bg-theme bg-opacity-25 '
                              className='w-100  '
                              isLoading={loading}
                              isSearchable={true}
                              isClearable
                              options={OptionsEquipments.filter(f => !f.IsVacant)}
                              value={OptionsEquipments.find(f => f.value === Id)}
                              placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                              formatOptionLabel={option => {
                                const isRTL = i18n.language === 'ar';
                                const imgSrc = option.PathImage || '/assets/img/Image/NoImg2.ico';

                                return (
                                  <div className='d-flex justify-content-between align-items-center'>
                                    <div className='d-flex align-items-center'>
                                      <img
                                        src={imgSrc}
                                        alt={option.label}
                                        onError={(e: any) => {
                                          e.target.onerror = null;
                                          e.target.src = '/assets/img/Image/NoImg2.ico';
                                        }}
                                        style={{
                                          width: '40px',
                                          height: '40px',
                                          objectFit: 'cover',
                                          marginLeft: isRTL ? '10px' : '0',
                                          marginRight: isRTL ? '0' : '10px',
                                          borderRadius: '4px'
                                        }}
                                      />
                                      <div>{option.label}</div>
                                    </div>
                                  </div>
                                );
                              }}
                            />
                          </div>
                        </div>
                        <div className='col-md-4'>
                          <div className='input-group flex-nowrap mb-3'>
                            <span className='input-group-text  fw-bold'>
                              <i className='fas fa-user	 me-2'></i>
                              {t('Driver')}
                            </span>
                            <Select
                              isDisabled
                              classNamePrefix='react-select'
                              // className='w-100 bg-theme bg-opacity-25 '
                              className='w-100  '
                              isLoading={loading}
                              isSearchable={true}
                              isClearable
                              options={OptionsDrivers}
                              value={OptionsDrivers.find(f => f.value === EquipmentData?.peopleId)}
                              placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                              onChange={(option: any) => formik.setFieldValue('peopleId', option.value)}
                              formatOptionLabel={option => (
                                <div className='d-flex justify-content-between   '>
                                  <div className=''>
                                    {option.hasVehicle && (
                                      <i className='fas fa-car text-theme me-2' title={t('AssignedVehicle')}></i>
                                    )}
                                    {option.label}
                                  </div>
                                  <div className='text-theme fw-bold'>{option.personNo}</div>
                                </div>
                              )}
                            />
                          </div>
                          <div className='input-group flex-nowrap'>
                            <span className='input-group-text fw-bold'>
                              <i className=' fa-fw bi bi-speedometer fa-lg me-2'></i>
                              {t('Odometer')}
                            </span>
                            <Form.Control
                              type='number'
                              name='odometer'
                              value={formik.values.odometer}
                              onChange={formik.handleChange}
                              className='form-control '
                            />
                          </div>
                        </div>
                        <div className='col-md-4'>
                          <div className='input-group flex-nowrap mb-3'>
                            <span className='input-group-text   fw-bold'>
                              <i className='far fa-calendar-alt	 me-2'></i>
                              {t('HandoverDate')}
                            </span>
                            <Form.Control
                              disabled
                              type='datetime-local'
                              name='deliveryDateFrom'
                              value={formik.values.deliveryDateFrom}
                              // onChange={formik.handleChange}
                              className='form-control '
                            />
                          </div>
                          <div className='input-group flex-nowrap'>
                            <span className='input-group-text   fw-bold'>
                              <i className='far fa-calendar-alt	 me-2'></i>
                              {t('TakeoverDate')}
                            </span>
                            <Form.Control
                              type='datetime-local'
                              name='DeliveryDateTo'
                              value={formik.values.DeliveryDateTo}
                              onChange={formik.handleChange}
                              className='form-control '
                            />
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </div>
              </div>

              {/* Inspection Items Section */}
              <Card className='mb-4'>
                {/* <CardHeader
                  className=' d-flex justify-content-between align-items-center'
                  style={{ cursor: 'pointer' }}
                >
                  <h5 className='mb-0'>
                    <i className='fas fa-clipboard-list me-2'></i>
                    {t('InspectionList')}
                  </h5>
                  <a
                    className='text-inverse text-opacity-50'
                    data-bs-toggle='collapse'
                    data-bs-target='#completedBoard'
                  >
                    <i className='fa fa-plus-circle'></i>
                  </a>
                </CardHeader> */}

                <CardHeader className='d-flex justify-content-between align-items-center'>
                  <h5 className='mb-0'>
                    <i className='fas fa-clipboard-list me-2'></i>
                    {t('InspectionList')}
                  </h5>
                  <div className='d-flex align-items-center gap-2'>
                    <button
                      type='button'
                      className={`btn btn-sm ${
                        formik.values.details?.every(d => d.value === '1')
                          ? 'btn-outline-danger'
                          : 'btn-outline-success'
                      }`}
                      onClick={() => {
                        const selectAll = !formik.values.details?.every(d => d.value === '1');
                        const updatedDetails = formik.values.details.map(d => ({ ...d, value: selectAll ? '1' : '0' }));
                        formik.setFieldValue('details', updatedDetails);
                      }}
                    >
                      {formik.values.details?.every(d => d.value === '1') ? t('DeselectAll') : t('SelectAll')}
                    </button>
                    <span className='ms-3 small'>
                      {t('Selected')}: {formik.values.details?.filter(d => d.value === '1')?.length} /{' '}
                      {formik.values.details?.length}
                    </span>
                    <a
                      className='text-inverse text-opacity-50'
                      data-bs-toggle='collapse'
                      data-bs-target='#completedBoard'
                    >
                      <i className='fa fa-plus-circle'></i>
                    </a>
                  </div>
                </CardHeader>
                <div className='collapse ' id='completedBoard'>
                  <CardBody>
                    <div className='row'>
                      {ScanElementList &&
                        formik.values.details &&
                        ScanElementList.scanningElements.map((item, index) => {
                          const detail = formik.values.details[index];

                          return (
                            <div key={index} className='col-md-4 mb-2'>
                              <div className='bg-inverse bg-opacity-10 rounded-2 p-2 border hover-highlight d-flex justify-content-between'>
                                <div className='fw-bold mb-0'>
                                  <span className='me-2 text-theme '>{index + 1}.</span>
                                  {i18n.language === 'en' ? item.name : item.name2}

                                  {item.description && (
                                    <PopoverCustom
                                      childern={<i className='fas fa-info-circle ms-2'></i>}
                                      Body={i18n.language === 'en' ? item.description : item.description2}
                                    />
                                  )}
                                </div>

                                <div className='text-center d-flex gap-2 justify-content-center'>
                                  <Button
                                    variant={detail?.value === '1' ? 'success' : 'outline-success'}
                                    onClick={() => formik.setFieldValue(`details[${index}].value`, '1')}
                                  >
                                    <i className='fas fa-check '></i>
                                  </Button>

                                  <Button
                                    variant={detail?.value === '0' ? 'danger' : 'outline-danger'}
                                    onClick={() => formik.setFieldValue(`details[${index}].value`, '0')}
                                  >
                                    <i className='fas fa-times'></i>
                                  </Button>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </CardBody>
                </div>
              </Card>

              {/* Diagram Section */}
              {ScanElementList?.kuroki && (
                <Card className='mb-4'>
                  <CardHeader
                    className='  text-white d-flex justify-content-between align-items-center'
                    style={{ cursor: 'pointer' }}
                  >
                    <h5 className='mb-0'>
                      <i className='fas fa-image me-2'></i>
                      {t('VehicleDiagram')}
                    </h5>
                    <a className='text-inverse text-opacity-50' data-bs-toggle='collapse' data-bs-target='#Kuroki'>
                      <i className='fa fa-plus-circle'></i>
                    </a>
                  </CardHeader>
                  <div className='collapse show' id='Kuroki'>
                    <CardBody>
                      <Kuroki formik={formik} KurokiImage={ScanElementList.kuroki.filePath ?? ''} />
                    </CardBody>
                  </div>
                </Card>
              )}

              {/* Notes & Attachments Section */}
              <div className='row mb-4'>
                <div className='col-md-6 mb-3'>
                  <Card className='h-100'>
                    <CardHeader className=' '>
                      <h5 className='mb-0'>
                        <i className='fas fa-edit me-2'></i>
                        {t('Notes')}
                      </h5>
                    </CardHeader>
                    <CardBody>
                      <Select
                        className='mb-2'
                        classNamePrefix='react-select'
                        placeholder={t('SelectPredefinedNote')}
                        options={predefinedNotesCategories.map(category => ({
                          label: category.label,
                          options: category.options.map(note => ({
                            value: note.text,
                            label: note.text
                          }))
                        }))}
                        onChange={(selectedOption: any) => {
                          if (selectedOption) {
                            addPredefinedNote(selectedOption.value);
                          }
                        }}
                        value={null}
                        isSearchable
                        menuPortalTarget={document.body}
                        styles={{
                          menuPortal: base => ({ ...base, zIndex: 9999 }),
                          option: (base, { isFocused, isSelected }) => ({
                            ...base,
                            backgroundColor: isSelected
                              ? 'var(--bs-theme)'
                              : isFocused
                              ? 'var(--bs-theme-opacity-25)'
                              : undefined,
                            color: isSelected ? 'white' : undefined
                          })
                        }}
                      />
                      <Form.Control
                        as='textarea'
                        rows={3}
                        name='description'
                        value={formik.values.description || ''}
                        onChange={formik.handleChange}
                        placeholder={t('AddYourNotesHere')}
                        // className='h-100 mb-3'
                      />
                    </CardBody>
                  </Card>
                </div>

                <div className='col-md-6 mb-3'>
                  <Card className='h-100'>
                    <CardHeader className=' '>
                      <h5 className='mb-0'>
                        <i className='fas fa-paperclip me-2'></i>
                        {t('Attachments')}
                      </h5>
                    </CardHeader>
                    <CardBody>
                      <FileUpload attachments={attachments} setAttachments={handleAttachments} />
                    </CardBody>
                  </Card>
                </div>
              </div>

              {/* Action Buttons */}

              {Object.keys(formik.errors).length > 0 && (
                <div className='alert alert-danger'>
                  <ul className='mb-0'>
                    {Object.entries(formik.errors).map(([field, error]: [string, any]) => (
                      <li key={field}>
                        <strong>{fieldNames[field] ?? field}:</strong> {error}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              <div className='d-flex justify-content-center gap-3 mt-2'>
                <button type='submit' className='btn btn-lg  btn-theme mb-1   rounded-0' disabled={formik.isSubmitting}>
                  {formik.isSubmitting ? (
                    <>
                      <span className='spinner-border spinner-border-sm me-2'></span>
                      {t('Saving')}...
                    </>
                  ) : (
                    <>
                      <i className='fas fa-save me-2'></i>
                      {t('Takeover')}
                    </>
                  )}
                </button>

                <button
                  type='button'
                  className='btn btn-lg  btn-default mb-1   rounded-0'
                  onClick={() => navigate('/FLEET/TakeOver', { replace: true })}
                >
                  <i className='fas fa-times me-2'></i>
                  {t('Cancel')}
                </button>
              </div>
            </Form>
          </div>
          <div className='tab-pane fade' id='HandoverDetiles'>
            {EquipmentData?.equipmentsAssignationId && (
              <DetilesScan assignationId={EquipmentData?.equipmentsAssignationId} scanningType={'Handover'} />
            )}
          </div>
        </div>
      </Loading>
    </>
  );
};

export default TakeOver;

// const TakeOver = ({
//   Id,
//   equipmentsAssignationDate,
//   equipmentsAssignationId,
//   onclose
// }: {
//   Id: string;
//   equipmentsAssignationDate: string;
//   equipmentsAssignationId: string;
//   onclose: () => void;
// }) => {

//   const [attachments, setAttachments] = useState<File[]>([]);
//   const { t, i18n } = useTranslation();
//   const dispatch = useAppDispatch();

//   const { OptionsEquipments, EquipmentsList, error, loading } = useGetEquipmentsList();
//   const { OptionsDrivers, loading: loading1, error: error1 } = useGetDriversList();
//   const EquipmentData = EquipmentsList?.find(f => f.id === Id);
//   const { ScanElementList, loading: loading2, error: error2 } = useAppSelector(state => state.FleetScan);

//   useEffect(() => {
//     dispatch(GetScanningElementList({ modelId: EquipmentData?.fleetModelId }));
//   }, [EquipmentData, dispatch]);

//   const formik = useFormik({
//     initialValues: {
//       id: equipmentsAssignationId,
//       fleetEquipmentsId: Id,
//       peopleId: EquipmentData?.peopleId,
//       deliveryDateFrom: equipmentsAssignationDate,
//       DeliveryDateTo: '',
//       description: '',
//       odometer: 0,

//       //--------------
//       details: ScanElementList?.scanningElements?.map(item => ({
//         // scanningMasterId: null,
//         scanningElementId: item.id,
//         value: '',
//         description: ''
//       })),
//       attachments: [],
//       isAddAttach: false,
//       markers: [
//         // {
//         //   xPosition: '',
//         //   yPosition: '',
//         //   shape: '',
//         //   color: '',
//         //   comment: '',
//         //   size: ''
//         // }
//       ]
//     },
//     enableReinitialize: true,
//     // validationSchema: EquipmentsAssignmentSchema(t),
//     onSubmit: values => {
//       const formData = new FormData();
//       formData.append('Id', values.id || '');
//       formData.append('FleetEquipmentsId', values.fleetEquipmentsId || '');
//       formData.append('PeopleId', values.peopleId || '');
//       formData.append('DeliveryDateFrom', values.deliveryDateFrom || '');
//       formData.append('DeliveryDateTo', values.DeliveryDateTo || '');
//       formData.append('Description', values.description || ' ');

//       formData.append('Scanning.LookupType', '');
//       formData.append('Scanning.Odometer', values.odometer?.toString() || '');

//       formData.append('Scanning.FleetEquipmentsId', values.fleetEquipmentsId || '');
//       formData.append('Scanning.DriverId', values.peopleId || '');
//       formData.append('Scanning.ScanningCode', '');
//       formData.append('Scanning.ScanningDate', values.DeliveryDateTo || '');
//       formData.append('Scanning.Description', values.description || '');
//       formData.append('Scanning.IsAddAttach', values.isAddAttach ? 'true' : 'false');

//       // رفع المرفقات
//       if (values.attachments && values.attachments.length > 0) {
//         values.attachments.forEach(file => {
//           formData.append('Scanning.Attach', file); // file من نوع File أو Blob
//         });
//       }

//       // Append details to formData
//       values.details.forEach((detail, index) => {
//         formData.append(`Scanning.Details[${index}].scanningElementId`, detail.scanningElementId);
//         formData.append(`Scanning.Details[${index}].value`, detail.value === '1' ? 'true' : 'false');

//         formData.append(`Scanning.Details[${index}].description`, detail.description);
//       });

//       // Append Markers to formData
//       values.markers.forEach((marker: any, index) => {
//         formData.append(`Scanning.Markers[${index}].xPosition`, marker.x?.toString() ?? '');
//         formData.append(`Scanning.Markers[${index}].yPosition`, marker.y?.toString() ?? '');
//         formData.append(`Scanning.Markers[${index}].shape`, marker.shape ?? '');
//         formData.append(`Scanning.Markers[${index}].color`, marker.color ?? '');
//         formData.append(`Scanning.Markers[${index}].comment`, marker.comment ?? '');
//         formData.append(`Scanning.Markers[${index}].size`, marker.size?.toString() ?? '');
//       });

//       dispatch(UpdatEquipmentsAssignment(formData))
//         .unwrap()
//         .then(res => {
//           if (res?.succeeded === true) {
//             CustomAlert({
//               action: 'Add',
//               msg: i18n.language === 'en' ? 'Take over completed successfully.' : 'تم الاستلام  بنجاح.'
//             });
//             dispatch(GetEquipmentsList());
//             onclose();
//           } else {
//             formik.setSubmitting(false);
//             CustomAlert({ action: 'Error', msg: res?.message });
//           }
//         })
//         .catch((error: any) => {
//           formik.setSubmitting(false);
//           CustomAlert({ action: 'Error' });
//         });
//     }
//   });

//   const handleAttachments: React.Dispatch<React.SetStateAction<File[]>> = value => {
//     setAttachments(prev => {
//       const newAttachments = typeof value === 'function' ? value(prev) : value;
//       if (newAttachments.length > 0) {
//         formik.setFieldValue('attachments', newAttachments);
//         formik.setFieldValue('isAddAttach', true);
//       } else {
//         formik.setFieldValue('attachments', []);
//         formik.setFieldValue('isAddAttach', false);
//       }
//       return newAttachments;
//     });
//   };

//   const predefinedNotesCategories = [
//     {
//       label: t('Oil and Filters'),
//       options: [
//         { id: 1, text: t('Oil change') },
//         { id: 2, text: t('Oil Filter change') },
//         { id: 3, text: t('Water Pump change') },
//         { id: 4, text: t('Deferential oil change') },
//         { id: 5, text: t('Gear oil change') }
//       ]
//     },
//     {
//       label: t('Electrical and Engine'),
//       options: [
//         { id: 6, text: t('Electrical work') },
//         { id: 7, text: t('Clutch work') },
//         { id: 8, text: t('Selfe motor work') },
//         { id: 9, text: t('Dainomo work') },
//         { id: 10, text: t('Engine Repair') },
//         { id: 11, text: t('Engine Head work') },
//         { id: 12, text: t('Diesel Pump repair work') },
//         { id: 13, text: t('Diesel pump Installation works') },
//         { id: 14, text: t('Diesel pump washing') }
//       ]
//     },
//     {
//       label: t('Body and Painting'),
//       options: [
//         { id: 15, text: t('Light work') },
//         { id: 16, text: t('Tending and painting work') },
//         { id: 17, text: t('Body parts work') },
//         { id: 18, text: t('Welding works') },
//         { id: 19, text: t('Safety barrier works') }
//       ]
//     },
//     {
//       label: t('Suspension and Wheels'),
//       options: [
//         { id: 20, text: t('Gear work') },
//         { id: 21, text: t('Connecting Rod works') },
//         { id: 22, text: t('Shockupsober works') },
//         { id: 23, text: t('Tire replace works') },
//         { id: 24, text: t('Wheel king pin change') },
//         { id: 25, text: t('Break works') }
//       ]
//     },
//     {
//       label: t('AC and Cooling'),
//       options: [
//         { id: 26, text: t('Radiator work') },
//         { id: 27, text: t('AC works') },
//         { id: 28, text: t('Frozen unit repair') }
//       ]
//     },
//     {
//       label: t('Washing and Cleaning'),
//       options: [
//         { id: 29, text: t('Engine washing') },
//         { id: 30, text: t('Car washing') }
//       ]
//     },
//     // {
//     //   label: t('Route Status'),
//     //   options: [
//     //     { id: 31, text: t('Route Number: vacation') },
//     //     { id: 32, text: t('Route Number: termination') },
//     //     { id: 33, text: t('Route Number: replace') },
//     //     { id: 34, text: t('Route Number: No route number') }
//     //   ]
//     // },
//     {
//       label: t('MVPI and Inspection'),
//       options: [{ id: 35, text: t('MVPI process work') }]
//     }
//   ];

//   // دالة لإضافة ملاحظة جاهزة إلى الحقل
//   const addPredefinedNote = (note: string) => {
//     const currentNotes = formik.values.description;
//     formik.setFieldValue('description', currentNotes ? `${currentNotes}\n- ${note}` : `- ${note}`);
//   };

//   return (
//     <>
//       <Loading loading={loading || loading1 || loading2} error={error || error1 || error2}>
//         <ul className='nav nav-tabs mb-3 d-flex justify-content-between align-items-center'>
//           <div className='d-flex'>
//             <li className='nav-item'>
//               <a className='nav-link active' id='pills-home-tab' data-bs-toggle='pill' href='#TakeOverForm'>
//                 <i className='fa-lg fas fa-clipboard-check me-2'></i>
//                 <span>{t('takeoverForm')}</span>
//                 <span className='badge bg-theme ms-2 px-3'>{OptionsEquipments.find(f => f.value === Id)?.label}</span>
//               </a>
//             </li>
//             <li className='nav-item'>
//               <a className='nav-link' id='pills-profile-tab' data-bs-toggle='pill' href='#HandoverDetiles'>
//                 <i className='fa-lg fas fa-file-alt me-2'></i>
//                  {t('handoverDetails')}
//               </a>
//             </li>
//           </div>

//           <li className='nav-item'>
//             <button type='button' className='btn   btn-close  ' onClick={onclose} />
//           </li>
//         </ul>

//         <div className='tab-content' id='pills-tabContent'>
//           <div className='tab-pane fade show active' id='TakeOverForm'>
//             <Form onSubmit={formik.handleSubmit}>
//               <div className='row mb-4   '>
//                 <div className='col-md-12 mb-3'>
//                   <Card className='h-100 '>
//                     <CardBody>
//                       <div className='row'>
//                         <div className='col-md-4'>
//                           <div className='input-group flex-nowrap'>
//                             <span className='input-group-text    fw-bold'>
//                               <i className='fas fa-car-side me-2'></i>
//                               {t('Vehicle')}
//                             </span>
//                             <Select
//                               isDisabled
//                               classNamePrefix='react-select'
//                               // className='w-100 bg-theme bg-opacity-25 '
//                               className='w-100  '
//                               isLoading={loading}
//                               isSearchable={true}
//                               isClearable
//                               options={OptionsEquipments.filter(f => !f.IsVacant)}
//                               value={OptionsEquipments.find(f => f.value === Id)}
//                               placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                               formatOptionLabel={option => {
//                                 const isRTL = i18n.language === 'ar';
//                                 const imgSrc = option.PathImage || '/assets/img/Image/NoImg2.ico';

//                                 return (
//                                   <div className='d-flex justify-content-between align-items-center'>
//                                     <div className='d-flex align-items-center'>
//                                       <img
//                                         src={imgSrc}
//                                         alt={option.label}
//                                         onError={(e: any) => {
//                                           e.target.onerror = null;
//                                           e.target.src = '/assets/img/Image/NoImg2.ico';
//                                         }}
//                                         style={{
//                                           width: '40px',
//                                           height: '40px',
//                                           objectFit: 'cover',
//                                           marginLeft: isRTL ? '10px' : '0',
//                                           marginRight: isRTL ? '0' : '10px',
//                                           borderRadius: '4px'
//                                         }}
//                                       />
//                                       <div>{option.label}</div>
//                                     </div>
//                                   </div>
//                                 );
//                               }}
//                             />
//                           </div>
//                         </div>
//                         <div className='col-md-4'>
//                           <div className='input-group flex-nowrap mb-3'>
//                             <span className='input-group-text  fw-bold'>
//                               <i className='fas fa-user	 me-2'></i>
//                               {t('Driver')}
//                             </span>
//                             <Select
//                               isDisabled
//                               classNamePrefix='react-select'
//                               // className='w-100 bg-theme bg-opacity-25 '
//                               className='w-100  '
//                               isLoading={loading}
//                               isSearchable={true}
//                               isClearable
//                               options={OptionsDrivers}
//                               value={OptionsDrivers.find(f => f.value === EquipmentData?.peopleId)}
//                               placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
//                               onChange={(option: any) => formik.setFieldValue('peopleId', option.value)}
//                               formatOptionLabel={option => (
//                                 <div className='d-flex justify-content-between   '>
//                                   <div className=''>
//                                     {option.hasVehicle && (
//                                       <i className='fas fa-car text-theme me-2' title={t('AssignedVehicle')}></i>
//                                     )}
//                                     {option.label}
//                                   </div>
//                                   <div className='text-theme fw-bold'>{option.personNo}</div>
//                                 </div>
//                               )}
//                             />
//                           </div>
//                           <div className='input-group flex-nowrap'>
//                             <span className='input-group-text fw-bold'>
//                               <i className=' fa-fw bi bi-speedometer fa-lg me-2'></i>
//                               {t('Odometer')}
//                             </span>
//                             <Form.Control
//                               type='number'
//                               name='odometer'
//                               value={formik.values.odometer}
//                               onChange={formik.handleChange}
//                               className='form-control '
//                             />
//                           </div>
//                         </div>
//                         <div className='col-md-4'>
//                           <div className='input-group flex-nowrap mb-3'>
//                             <span className='input-group-text   fw-bold'>
//                               <i className='far fa-calendar-alt	 me-2'></i>
//                               {t('HandoverDate')}
//                             </span>
//                             <Form.Control
//                               disabled
//                               type='datetime-local'
//                               name='deliveryDateFrom'
//                               value={formik.values.deliveryDateFrom}
//                               // onChange={formik.handleChange}
//                               className='form-control '
//                             />
//                           </div>
//                           <div className='input-group flex-nowrap'>
//                             <span className='input-group-text   fw-bold'>
//                               <i className='far fa-calendar-alt	 me-2'></i>
//                               {t('TakeoverDate')}
//                             </span>
//                             <Form.Control
//                               type='datetime-local'
//                               name='DeliveryDateTo'
//                               value={formik.values.DeliveryDateTo}
//                               onChange={formik.handleChange}
//                               className='form-control '
//                             />
//                           </div>
//                         </div>
//                       </div>
//                     </CardBody>
//                   </Card>
//                 </div>
//               </div>

//               {/* Inspection Items Section */}
//               <Card className='mb-4'>
//                 <CardHeader
//                   className=' d-flex justify-content-between align-items-center'
//                   style={{ cursor: 'pointer' }}
//                 >
//                   <h5 className='mb-0'>
//                     <i className='fas fa-clipboard-list me-2'></i>
//                     {t('InspectionList')}
//                   </h5>
//                   <a
//                     className='text-inverse text-opacity-50'
//                     data-bs-toggle='collapse'
//                     data-bs-target='#completedBoard'
//                   >
//                     <i className='fa fa-plus-circle'></i>
//                   </a>
//                 </CardHeader>
//                 <div className='collapse ' id='completedBoard'>
//                   <CardBody>
//                     <div className='row'>
//                       {ScanElementList &&
//                         formik.values.details &&
//                         ScanElementList.scanningElements.map((item, index) => {
//                           const detail = formik.values.details[index];

//                           return (
//                             <div key={index} className='col-md-4 mb-2'>
//                               <div className='bg-inverse bg-opacity-10 rounded-2 p-2 border hover-highlight d-flex justify-content-between'>
//                                 <div className='fw-bold mb-0'>
//                                   <span className='me-2 text-theme '>{index + 1}.</span>
//                                   {i18n.language === 'en' ? item.name : item.name2}

//                                   {item.description && (
//                                     <PopoverCustom
//                                       childern={<i className='fas fa-info-circle ms-2'></i>}
//                                       Body={i18n.language === 'en' ? item.description : item.description2}
//                                     />
//                                   )}
//                                 </div>

//                                 <div className='text-center d-flex gap-2 justify-content-center'>
//                                   <Button
//                                     variant={detail?.value === '1' ? 'success' : 'outline-success'}
//                                     onClick={() => formik.setFieldValue(`details[${index}].value`, '1')}
//                                   >
//                                     <i className='fas fa-check '></i>
//                                   </Button>

//                                   <Button
//                                     variant={detail?.value === '0' ? 'danger' : 'outline-danger'}
//                                     onClick={() => formik.setFieldValue(`details[${index}].value`, '0')}
//                                   >
//                                     <i className='fas fa-times'></i>
//                                   </Button>
//                                 </div>
//                               </div>
//                             </div>
//                           );
//                         })}
//                     </div>
//                   </CardBody>
//                 </div>
//               </Card>

//               {/* Diagram Section */}
//               {ScanElementList?.kuroki && (
//                 <Card className='mb-4'>
//                   <CardHeader
//                     className='  text-white d-flex justify-content-between align-items-center'
//                     style={{ cursor: 'pointer' }}
//                   >
//                     <h5 className='mb-0'>
//                       <i className='fas fa-image me-2'></i>
//                       {t('VehicleDiagram')}
//                     </h5>
//                     <a className='text-inverse text-opacity-50' data-bs-toggle='collapse' data-bs-target='#Kuroki'>
//                       <i className='fa fa-plus-circle'></i>
//                     </a>
//                   </CardHeader>
//                   <div className='collapse show' id='Kuroki'>
//                     <CardBody>
//                       <Kuroki formik={formik} KurokiImage={ScanElementList.kuroki.filePath ?? ''} />
//                     </CardBody>
//                   </div>
//                 </Card>
//               )}

//               {/* Notes & Attachments Section */}
//               <div className='row mb-4'>
//                 <div className='col-md-6 mb-3'>
//                   <Card className='h-100'>
//                     <CardHeader className=' '>
//                       <h5 className='mb-0'>
//                         <i className='fas fa-edit me-2'></i>
//                         {t('Notes')}
//                       </h5>
//                     </CardHeader>
//                     <CardBody>
//                       <Select
//                         className='mb-2'
//                         classNamePrefix='react-select'
//                         placeholder={t('SelectPredefinedNote')}
//                         options={predefinedNotesCategories.map(category => ({
//                           label: category.label,
//                           options: category.options.map(note => ({
//                             value: note.text,
//                             label: note.text
//                           }))
//                         }))}
//                         onChange={(selectedOption: any) => {
//                           if (selectedOption) {
//                             addPredefinedNote(selectedOption.value);
//                           }
//                         }}
//                         value={null}
//                         isSearchable
//                         menuPortalTarget={document.body}
//                         styles={{
//                           menuPortal: base => ({ ...base, zIndex: 9999 }),
//                           option: (base, { isFocused, isSelected }) => ({
//                             ...base,
//                             backgroundColor: isSelected
//                               ? 'var(--bs-theme)'
//                               : isFocused
//                               ? 'var(--bs-theme-opacity-25)'
//                               : undefined,
//                             color: isSelected ? 'white' : undefined
//                           })
//                         }}
//                       />
//                       <Form.Control
//                         as='textarea'
//                         rows={3}
//                         name='description'
//                         value={formik.values.description}
//                         onChange={formik.handleChange}
//                         placeholder={t('AddYourNotesHere')}
//                         // className='h-100 mb-3'
//                       />
//                     </CardBody>
//                   </Card>
//                 </div>

//                 <div className='col-md-6 mb-3'>
//                   <Card className='h-100'>
//                     <CardHeader className=' '>
//                       <h5 className='mb-0'>
//                         <i className='fas fa-paperclip me-2'></i>
//                         {t('Attachments')}
//                       </h5>
//                     </CardHeader>
//                     <CardBody>
//                       <FileUpload attachments={attachments} setAttachments={handleAttachments} />
//                     </CardBody>
//                   </Card>
//                 </div>
//               </div>

//               {/* Action Buttons */}

//               <div className='d-flex justify-content-center gap-3 mt-3'>
//                 <button
//                   type='submit'
//                   className='btn btn-lg  btn-theme mb-1 w-100 rounded-0'
//                   disabled={formik.isSubmitting}
//                 >
//                   {formik.isSubmitting ? (
//                     <>
//                       <span className='spinner-border spinner-border-sm me-2'></span>
//                       {t('Saving')}...
//                     </>
//                   ) : (
//                     <>
//                       <i className='fas fa-save me-2'></i>
//                       {t('Takeover')}
//                     </>
//                   )}
//                 </button>

//                 <button type='button' className='btn btn-lg  btn-default mb-1 w-100 rounded-0' onClick={onclose}>
//                   <i className='fas fa-times me-2'></i>
//                   {t('Cancel')}
//                 </button>
//               </div>
//             </Form>
//           </div>
//           <div className='tab-pane fade' id='HandoverDetiles'>
//             <DetilesScan assignationId={equipmentsAssignationId} scanningType={'Handover'} />
//           </div>
//         </div>
//       </Loading>
//     </>
//   );
// };

// export default TakeOver;
